module.exports = __webpack_public_path__ + "img/map1.7db0b132.png";